module.exports = {"TXTWCL_Go_to_slide_N0":{"id":"TXTWCL_Go_to_slide_N0","defaultMessage":"Перейти к слайду {slideNumber}"}}